var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BaseComponent } from "../../views/base.component";
import { ModalService } from "../../views/modal/base_modal.component";
import { HelperService } from "../../lib/helper.service";
import { TranslateService } from "../../translate/translate.service";
import { EventsService } from "../../lib/EventsService";
import { FilterFormService } from "../../views/filter_form/filter_form.service";
import { ActivatedRoute, Router } from "@angular/router";
import { ChartParams } from "../../views/chart/chart.component";
import * as qs from 'qs';
import { FilterParams } from "../../models/filter_form.model";
import merge from 'lodash-es/merge';
import { AlertComponent } from "../../views/modal/alert.component";
import { BillingService2 } from "../billing.service";
var ManualComponent = /** @class */ (function (_super) {
    __extends(ManualComponent, _super);
    function ManualComponent(eventsService, activatedRoute, translate, router, modalService, filter, route, helper, service2) {
        var _this = _super.call(this, eventsService, service2, activatedRoute, filter, translate) || this;
        _this.eventsService = eventsService;
        _this.activatedRoute = activatedRoute;
        _this.translate = translate;
        _this.router = router;
        _this.modalService = modalService;
        _this.filter = filter;
        _this.route = route;
        _this.helper = helper;
        _this.service2 = service2;
        _this.totals = {
            totalRec: 0,
            totalPaidRec: 0,
            totalFailRec: 0,
        };
        _this.paidChart = new ChartParams();
        _this.paidByProcessorChart = new ChartParams();
        _this.paidByType = new ChartParams();
        _this.stats = [];
        _this.addFilterParams = {
            userType: 'user',
            isBilling: true,
            dateFilters: ['intBillingDateTo', 'billingDateTo', 'datePaid'],
            dateType: 'datePaid'
        };
        _this.paidByType.setOptions({
            type: 'pie'
        });
        return _this;
    }
    ManualComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        if (!me.doReload.total) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getTotal()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        if (!me.doReload.chart) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.getCharts()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (!me.doReload.pagination) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.getPagination()];
                    case 5:
                        _a.sent();
                        _a.label = 6;
                    case 6:
                        if (!me.doReload.stats) return [3 /*break*/, 8];
                        return [4 /*yield*/, this.getStats()];
                    case 7:
                        _a.sent();
                        _a.label = 8;
                    case 8:
                        this.doReload.reset();
                        return [2 /*return*/];
                }
            });
        });
    };
    ManualComponent.prototype.getTotal = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, totals;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.totalsLoader = true;
                        return [4 /*yield*/, me.service2.manualPaid.total(me.filter.filterParams).toPromise()];
                    case 1:
                        totals = (_a.sent()).totals;
                        me.totals = totals;
                        me.totalsLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ManualComponent.prototype.getCharts = function () {
        return __awaiter(this, void 0, void 0, function () {
            var charts, charts2, charts3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.paidChart.showLoader();
                        return [4 /*yield*/, this.service2.manualPaid.chart(this.filter.filterParams, 'chart/paid').toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        this.paidChart.data = charts;
                        this.paidChart.hideLoader();
                        this.paidByProcessorChart.showLoader();
                        return [4 /*yield*/, this.service2.manualPaid.chart(this.filter.filterParams, 'chart/proccessor').toPromise()];
                    case 2:
                        charts2 = (_a.sent()).charts;
                        this.paidByProcessorChart.data = charts2;
                        this.paidByProcessorChart.hideLoader();
                        this.paidByType.showLoader();
                        return [4 /*yield*/, this.service2.manualPaid.chart(this.filter.filterParams, 'chart/type').toPromise()];
                    case 3:
                        charts3 = (_a.sent()).charts;
                        this.paidByType.data = charts3;
                        this.paidByType.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    ManualComponent.prototype.getPagination = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, pagination;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.paginationLoader = true;
                        return [4 /*yield*/, me.service2.manualPaid.pagination(me.filter.filterParams).toPromise()];
                    case 1:
                        pagination = _a.sent();
                        me.pagination.fill(pagination);
                        me.paginationLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ManualComponent.prototype.getStats = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.statsLoader = true;
                        return [4 /*yield*/, me.service2.manualPaid.stats(me.filter.getCopyFilterParams({
                                paginationDate: me.pagination.getDate()
                            })).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        me.stats = stats;
                        me.statsLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ManualComponent.prototype.onPageChange = function () {
        var me = this;
        me.doReload.onlyStats();
        me.filter.filterParams.page = me.pagination.page;
        me.filter.filterParams.dateFilterParams = me.filter.getDateFilterParams(me.filter.filterParams, this.filter.addFilterParams);
        var params = me.filter.getApplyFilters(me.filter.filterParams), url = me.router.url.split('?')[0];
        params = qs.stringify(params, { encode: false });
        me.router.navigateByUrl(url + "?" + params, { relativeTo: me.activatedRoute });
    };
    ManualComponent.prototype.applyFilters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                params = this.filter.getApplyFilters(this.filter.filterParams), url = this.router.url.split('?')[0];
                params = qs.stringify(params, { encode: false });
                this.router.navigateByUrl(url + "?" + params, { relativeTo: this.route });
                return [2 /*return*/];
            });
        });
    };
    ManualComponent.prototype.resetFilters = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                this.filter.filterParams = new FilterParams();
                this.filter.filterParams = merge({}, this.filter.filterParams, this.filter.addFilterParams);
                this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
                params = merge({}, this.filter.getDiffParams(this.filter.filterParams)), url = this.router.url.split('?')[0];
                delete params.dateFilters;
                delete params.dateFilterParams;
                this.router.navigate([url], { relativeTo: this.route, queryParams: params });
                return [2 /*return*/];
            });
        });
    };
    ManualComponent.prototype.downloadButton = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me;
            return __generator(this, function (_a) {
                me = this;
                window.location.href = me.service2.manualPaid.downloadFileRoute(me.filter.filterParams);
                me.modalService.open(AlertComponent, {
                    title: 'INFO',
                    message: this.translate.__A('common.download file')
                });
                return [2 /*return*/];
            });
        });
    };
    return ManualComponent;
}(BaseComponent));
export { ManualComponent };
